const SECTION_MARKERS = [
  "## Transcript",
  "## Output",
  "## AI Response",
  "## Extracted Answers",
];

export const extractTransformableText = (content: string): string => {
  const trimmedContent = content.trim();
  if (!trimmedContent) {
    return "";
  }

  for (const marker of SECTION_MARKERS) {
    const markerIndex = trimmedContent.indexOf(marker);
    if (markerIndex >= 0) {
      const afterMarker = trimmedContent.slice(markerIndex + marker.length).trim();
      if (afterMarker) {
        return afterMarker;
      }
    }
  }

  const withoutTopHeading = trimmedContent.replace(/^#\s[^\n]+\n*/u, "").trim();
  return withoutTopHeading.replace(/\n{3,}/g, "\n\n").trim();
};
